import { render, staticRenderFns } from "./PriceProposals.vue?vue&type=template&id=0f241b6c&scoped=true"
import script from "./PriceProposals.vue?vue&type=script&lang=js"
export * from "./PriceProposals.vue?vue&type=script&lang=js"
import style0 from "./PriceProposals.vue?vue&type=style&index=0&id=0f241b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f241b6c",
  null
  
)

export default component.exports